import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';

export default function deficienciesReducer(state = initialstate.deficiencies, action) {
    switch (action.type) {
        case types.GET_DEFICIENCIES_BY_DOCUMENTID:
            if (action.response) {
                
                return !_.isEmpty(action.response) ? action.response : {
                    totalEntityCount: 0,
                    pages: 1,
                    page: 1,
                    data: []
                };
            }
            break;
        default:
            return state;
    }
}   